var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.3121 0.388672H7.7C3.104 0.388672 0.5 2.99267 0.5 7.58867V20.1887C0.5 24.7847 3.104 27.3887 7.7 27.3887H20.3121C24.908 27.3887 27.5 24.7847 27.5 20.1887V7.58867C27.5 2.99267 24.908 0.388672 20.3121 0.388672Z",
    fill: "#CE2600"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5268_21751)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 17.1387C10.2426 17.1387 11.25 16.1313 11.25 14.8887C11.25 13.646 10.2426 12.6387 9 12.6387C7.75736 12.6387 6.75 13.646 6.75 14.8887C6.75 16.1313 7.75736 17.1387 9 17.1387Z",
    stroke: "#CE2600",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 17.6387C12.2426 17.6387 13.25 16.6313 13.25 15.3887C13.25 14.146 12.2426 13.1387 11 13.1387C9.75736 13.1387 8.75 14.146 8.75 15.3887C8.75 16.6313 9.75736 17.6387 11 17.6387Z",
    stroke: "#CE2600",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 18.3887C13.9926 18.3887 15 17.3813 15 16.1387C15 14.896 13.9926 13.8887 12.75 13.8887C11.5074 13.8887 10.5 14.896 10.5 16.1387C10.5 17.3813 11.5074 18.3887 12.75 18.3887Z",
    stroke: "#CE2600",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16.8887C17.2426 16.8887 18.25 15.8813 18.25 14.6387C18.25 13.396 17.2426 12.3887 16 12.3887C14.7574 12.3887 13.75 13.396 13.75 14.6387C13.75 15.8813 14.7574 16.8887 16 16.8887Z",
    stroke: "#CE2600",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.875 15.8887C18.6344 15.8887 19.25 15.2731 19.25 14.5137C19.25 13.7543 18.6344 13.1387 17.875 13.1387C17.1156 13.1387 16.5 13.7543 16.5 14.5137C16.5 15.2731 17.1156 15.8887 17.875 15.8887Z",
    stroke: "#CE2600",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 16.1387C16.8844 16.1387 17.5 15.5231 17.5 14.7637C17.5 14.0043 16.8844 13.3887 16.125 13.3887C15.3656 13.3887 14.75 14.0043 14.75 14.7637C14.75 15.5231 15.3656 16.1387 16.125 16.1387Z",
    stroke: "#CE2600",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16.1387C9.69036 16.1387 10.25 15.579 10.25 14.8887C10.25 14.1983 9.69036 13.6387 9 13.6387C8.30964 13.6387 7.75 14.1983 7.75 14.8887C7.75 15.579 8.30964 16.1387 9 16.1387Z",
    stroke: "#CE2600",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.89505 14.6387C5.79988 15.124 5.75 15.6255 5.75 16.1387C5.75 17.9285 6.35676 19.5767 7.37582 20.8887H19.6242C20.6432 19.5767 21.25 17.9285 21.25 16.1387C21.25 15.6255 21.2001 15.124 21.1049 14.6387H5.89505Z",
    fill: "#CE2600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 15.6387H10.5",
    stroke: "#FFD24D",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 21.1387H20.5022M19.75 5.88867L10 9.13867M20.25 9.88867H9",
    stroke: "#CE2600",
    strokeOpacity: 0.74,
    strokeWidth: 0.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M11 8.13867V11.3983M9 9.88867V11.6387M9.75 9.13867V10.8887",
    stroke: "#CE2600",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5268_21751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(5.5 5.38867)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.ffa92450a133826eb740e7eed129fa02.svg";
export { ForwardRef as ReactComponent };